import React, { Component } from 'react';
export default class Captcha extends Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div style={{
                backgroundColor: 'rgb(230, 230, 230, .4)',
                position: 'absolute',
                width: '200px',
                height: '43px',
                top: '4px',
                left: '1px'
            }}>
            </div>
        )
    }
}
